<template>
  <div class="flex gap-3 w-full h-min overflow-x-scroll">
    <div
      class="flex items-center justify-center "
    >
      <label
        :for="inputId"
        :style="{'aspect-ratio': 3/4}"
        class="flex flex-col items-center justify-center w-full border-2 border-dashed border-gray-200 rounded-2xl cursor-pointer bg-white hover:bg-gray-100"
      >
        <div class="flex flex-col items-center justify-center p-4 w-32 ">
          <div v-if="!uploadInProgress" class="flex flex-col items-center justify-center gap-2">
            <i class="pi pi-plus text-gray-500"/>
            <span class="font-light text-xs text-center">{{label}}</span>
          </div>
          <loader v-else/>
        </div>
        <input
          :id="inputId"
          type="file"
          class="hidden"
          accept="image/png, image/jpeg, image/webp"
          multiple
          @change="selectPhotoWeb"
        />
      </label>
    </div>

    <div
      v-for="image of images"
      :key="image"
      style="aspect-ratio: 3/4"
      class="flex flex-none justify-center items-center relative rounded-2xl overflow-hidden w-32 border-2 border-dashed border-gray-200">
      <img class="w-full h-full object-cover" :src="image" alt="image to upload"/>
      <div
        class="flex flex-row gap-1 bg-black text-black absolute justify-center items-center p-2 rounded-full bg-opacity-50 top-1 left-1"
        @click="removeImage(image)"
      >
        <i class="pi pi-times text-xs text-white"/>
      </div>
    </div>
  </div>

</template>

<script lang="ts" setup>
import {PropType, ref} from 'vue';
import {generateRandomId} from "@app/utils/strings";
import {SharedApi} from "@app/api/admin";

const emit = defineEmits(['imagesChange'])
const props = defineProps({
  images: {type: Array as PropType<Array<string>>, required: false, default: () => []},
  label: {
    type: String,
    required: false,
    default: 'בחירת תמונות'
  }
})

const inputId = generateRandomId(10);

const uploadInProgress = ref(false);
const images = ref<string[]>(props.images);

const selectPhotoWeb = async (event: any) => {
  const filesToUpload: any[] = event.target.files;
  if (filesToUpload.length > 0) {
    uploadInProgress.value = true;
    try {
      const formData = new FormData();
      for (const fileToUpload of filesToUpload)
        formData.append(fileToUpload.name, fileToUpload);
      const responseImages = await SharedApi.uploadImages(formData);
      images.value.push(...responseImages);
      console.log('responseImages', responseImages)
      emit('imagesChange', responseImages)

    } catch (e) {
      console.error(e);
    }
    uploadInProgress.value = false;
  }
};

const removeImage = (imageUrl: string) => {
  const _images = [...images.value];
  images.value.splice(0);
  images.value.push(..._images.filter(x => x !== imageUrl));
  emit('imagesChange', images.value)
};
</script>

<style scoped></style>
